// All languages supported by DeepL API
// See: https://developers.deepl.com/docs/resources/supported-languages

export interface Language {
    code: string;
    name: string;
    deeplCode: string; // DeepL API language code
    flag: string; // Emoji flag
}

export const SUPPORTED_LANGUAGES: Language[] = [
    { code: 'de', name: 'Deutsch', deeplCode: 'DE', flag: '🇩🇪' },
    { code: 'en', name: 'English', deeplCode: 'EN', flag: '🇬🇧' },
    { code: 'es', name: 'Español', deeplCode: 'ES', flag: '🇪🇸' },
    { code: 'fr', name: 'Français', deeplCode: 'FR', flag: '🇫🇷' },
    { code: 'it', name: 'Italiano', deeplCode: 'IT', flag: '🇮🇹' },
    { code: 'nl', name: 'Nederlands', deeplCode: 'NL', flag: '🇳🇱' },
    { code: 'pl', name: 'Polski', deeplCode: 'PL', flag: '🇵🇱' },
    { code: 'pt', name: 'Português', deeplCode: 'PT', flag: '🇵🇹' },
    { code: 'ru', name: 'Русский', deeplCode: 'RU', flag: '🇷🇺' },
    { code: 'ja', name: '日本語', deeplCode: 'JA', flag: '🇯🇵' },
    { code: 'zh', name: '中文', deeplCode: 'ZH', flag: '🇨🇳' },
    { code: 'bg', name: 'Български', deeplCode: 'BG', flag: '🇧🇬' },
    { code: 'cs', name: 'Čeština', deeplCode: 'CS', flag: '🇨🇿' },
    { code: 'da', name: 'Dansk', deeplCode: 'DA', flag: '🇩🇰' },
    { code: 'el', name: 'Ελληνικά', deeplCode: 'EL', flag: '🇬🇷' },
    { code: 'et', name: 'Eesti', deeplCode: 'ET', flag: '🇪🇪' },
    { code: 'fi', name: 'Suomi', deeplCode: 'FI', flag: '🇫🇮' },
    { code: 'hu', name: 'Magyar', deeplCode: 'HU', flag: '🇭🇺' },
    { code: 'id', name: 'Bahasa Indonesia', deeplCode: 'ID', flag: '🇮🇩' },
    { code: 'ko', name: '한국어', deeplCode: 'KO', flag: '🇰🇷' },
    { code: 'lt', name: 'Lietuvių', deeplCode: 'LT', flag: '🇱🇹' },
    { code: 'lv', name: 'Latviešu', deeplCode: 'LV', flag: '🇱🇻' },
    { code: 'nb', name: 'Norsk', deeplCode: 'NB', flag: '🇳🇴' },
    { code: 'ro', name: 'Română', deeplCode: 'RO', flag: '🇷🇴' },
    { code: 'sk', name: 'Slovenčina', deeplCode: 'SK', flag: '🇸🇰' },
    { code: 'sl', name: 'Slovenščina', deeplCode: 'SL', flag: '🇸🇮' },
    { code: 'sv', name: 'Svenska', deeplCode: 'SV', flag: '🇸🇪' },
    { code: 'tr', name: 'Türkçe', deeplCode: 'TR', flag: '🇹🇷' },
    { code: 'uk', name: 'Українська', deeplCode: 'UK', flag: '🇺🇦' },
];

export function getLanguageByCode(code: string): Language | undefined {
    return SUPPORTED_LANGUAGES.find(lang => lang.code === code);
}

export function getDeeplCode(code: string): string {
    const lang = getLanguageByCode(code);
    return lang?.deeplCode || code.toUpperCase();
}
